<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('乐谱标题')" prop="title">
        <a-input v-model="form.title" :maxLength="200" :placeholder="$t('请输入')+$t('乐谱标题')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('分类')" prop="categoryId">
        <a-select v-model="form.categoryId" :placeholder="$t('请选择')+$t('分类')" allow-clear show-search option-filter-prop="children">
          <a-select-option v-for="item in categoryOptions" :key="item.id" :value="item.id">{{ item.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('封面图')" prop="coverPic">
        <oss-upload-single :height="100" :width="100" v-model="form.coverPic" prefix="sheet" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('难度')" prop="difficulty">
        <a-select v-model="form.difficulty" :placeholder="$t('请选择')+$t('难度')" allow-clear>
          <a-select-option :value="10">{{ $t('入门') }}</a-select-option>
          <a-select-option :value="20">{{ $t('初级') }}</a-select-option>
          <a-select-option :value="30">{{ $t('中级') }}</a-select-option>
          <a-select-option :value="40">{{ $t('高级') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('曲风')" prop="style">
        <a-input v-model="form.style" :maxLength="50" :placeholder="$t('请输入')+$t('曲风')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('文件类型')" prop="fileType">
        <a-radio-group v-model="form.fileType">
          <a-radio :value="10">{{ $t('图片') }}</a-radio>
          <a-radio :value="20">PDF</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('乐谱文件')" prop="fileUrls">
        <oss-upload-multi :max-count="20" v-model="form.fileUrls" prefix="sheet" type="img,pdf"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('简介')" prop="intro">
        <a-input v-model="form.intro" :maxLength="1000" :placeholder="$t('请输入')+$t('简介')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('是否可下载')" prop="isDownloadable">
        <a-switch v-model="form.isDownloadable" />
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="21474836" style="width: 100%" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-input v-model="form.remark" :maxLength="200" :placeholder="$t('请输入')+$t('备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSheet, addSheet, updateSheet } from '@/api/sheet/sheet'
import { listSheetCategory } from '@/api/sheet/category'
import { mapGetters } from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue"
import OssUploadMulti from "@/components/OssUploadMulti/index.vue"

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle,
    OssUploadMulti
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      categoryOptions: [],
      form: this.initForm(),
      open: false,
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        fileType: [{ required: true, message: '请选择文件类型', trigger: 'change' }],
        fileUrls: [{ required: true, message: '请上传乐谱文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created () {
    this.loadCategories()
  },
  methods: {
    initForm() {
      return {
        id: null,
        title: null,
        coverPic: null,
        categoryId: undefined,
        difficulty: undefined,
        style: null,
        fileType: 10,
        fileUrls: null,
        intro: null,
        isDownloadable: true,
        sort: 0,
        remark: null
      }
    },
    loadCategories() {
      listSheetCategory({}).then(response => {
        this.categoryOptions = (response.data || []).map(item => ({
          id: item.id,
          label: item.parentCategoryName ? (item.parentCategoryName + ' / ' + item.categoryName) : item.categoryName
        }))
      })
    },
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.form = this.initForm()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getSheet({ "id": id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          title: data.title,
          coverPic: data.coverPic,
          categoryId: data.categoryId,
          difficulty: data.difficulty,
          style: data.style,
          fileType: data.fileType,
          fileUrls: data.fileUrls,
          intro: data.intro,
          isDownloadable: data.isDownloadable,
          sort: data.sort,
          remark: data.remark
        }
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSheet(this.form).then(response => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSheet(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
